var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIdCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M453.332 0H58.668C26.305 0 0 26.305 0 58.668v266.664C0 357.695 26.305 384 58.668 384h394.664C485.695 384 512 357.695 512 325.332V58.668C512 26.305 485.695 0 453.332 0zM160 85.332c29.398 0 53.332 23.938 53.332 53.336C213.332 168.062 189.398 192 160 192s-53.332-23.938-53.332-53.332c0-29.398 23.934-53.336 53.332-53.336zm96 197.336c0 8.832-7.168 16-16 16H80c-8.832 0-16-7.168-16-16V272c0-32.363 26.305-58.668 58.668-58.668h74.664C229.695 213.332 256 239.637 256 272zm176 16H314.668c-8.832 0-16-7.168-16-16s7.168-16 16-16H432c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0-85.336H314.668c-8.832 0-16-7.168-16-16s7.168-16 16-16H432c8.832 0 16 7.168 16 16s-7.168 16-16 16zM432 128H314.668c-8.832 0-16-7.168-16-16s7.168-16 16-16H432c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdCard);
export default __webpack_public_path__ + "static/media/userIdCard.83b5979a167616bbdcf9ba41fe0d8a57.svg";
export { ForwardRef as ReactComponent };